"use strict";import{tag as s}from"../custom-tag.js";export function starIcon({height:a=16,width:l=16,hidden:t=!1,title:r="Star"}={}){return s`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${l}
      height=${a}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${t?"true":"false"}"
      role="img"
      aria-label="${r}"
    >
      <mask
        id="star_svg__mask0_6875_6484"
        width="20"
        height="20"
        x="2"
        y="2"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          d="M17.799 21.056a.53.53 0 0 1-.267-.07l-5.529-2.921-5.552 2.921a.59.59 0 0 1-.615 0 .57.57 0 0 1-.22-.568l1.055-6.178-4.486-4.428a.57.57 0 0 1-.15-.614.59.59 0 0 1 .463-.395l6.213-.88 2.77-5.622a.603.603 0 0 1 1.044 0l2.77 5.622 6.213.904a.59.59 0 0 1 .464.394.57.57 0 0 1-.151.59l-4.486 4.383 1.055 6.178a.57.57 0 0 1-.22.568.57.57 0 0 1-.371.116m-5.796-4.22q.142 0 .267.07l4.787 2.504-.916-5.32a.59.59 0 0 1 .162-.51l3.872-3.78-5.344-.776a.57.57 0 0 1-.44-.313l-2.388-4.845L9.615 8.71a.57.57 0 0 1-.44.313L3.889 9.8l3.872 3.78a.6.6 0 0 1 .162.51l-.916 5.32 4.787-2.504a.5.5 0 0 1 .209-.07"
        />
      </mask>
      <g mask="url(#star_svg__mask0_6875_6484)">
        <path fill="currentColor" d="M24 0H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=star.js.map
